(function() {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    const hasLangParam = urlParams.has('lang');
    let currentRegion = 'us'; // Default to US if no region prefix 

    // Extract region from current path (only es-mx and en-mx are separate regions)
    if (currentPath.includes('/es-mx')) {
        currentRegion = 'es-mx';
    } else if (currentPath.includes('/en-mx')) {
        currentRegion = 'en-mx';
    }
    // Note: /es paths are treated as US region

    // Check if region is stored in localStorage
    const storedRegion = localStorage.getItem('userRegion');

    if (!storedRegion) {
        // First time loading - check if user was already redirected by the server
        const isBasePath = currentPath === '/' || (!currentPath.includes('/es-mx') && !currentPath.includes('/en-mx'));
        const hasMXRegion = currentPath.includes('/es-mx') || currentPath.includes('/en-mx');
        
        // If no region in path and no localStorage, but has MX regions or ?lang=en param
        // it means user was already redirected by the server, so save as 'us' and don't redirect
        if (isBasePath && hasLangParam) {
            localStorage.setItem('userRegion', 'us');
            console.log('User already redirected by server (base path or lang param), saving as us');
        } else if (hasMXRegion) {
            // User is on MX region, save the current region
            localStorage.setItem('userRegion', currentRegion);
            console.log('First visit on MX region, saving:', currentRegion);
        }

        const ref = document.referrer; 
        const currentSearch = window.location.search;

        const refMatch = ref.match(/\/pages\/(purecreatine(?:-mariana)?-2025)/);
        const localeMatch = currentPath.match(/^\/(es-mx|en-mx|es)(\/|$)/);
        const langParam = currentSearch.includes('?lang=en');

        const hasValidReferrer = refMatch && refMatch[0];
        const hasValidLocale = localeMatch && localeMatch[1];

        if (hasValidReferrer && hasValidLocale && !langParam) {
            const localePrefix = `/${localeMatch[1]}`; 
            const targetPath = refMatch[0]; // e.g. "/pages/purecreatine-2025"
            const targetURL = `${window.location.origin}${localePrefix}${targetPath}`;
            window.location.href = targetURL;
        }

        if (hasValidReferrer && langParam) {
            const targetPath = refMatch[0];
            const targetURL = `${window.location.origin}${targetPath}`;
            window.location.href = targetURL;
        }

        // Product redirect logic (US - MX) for first-time visits
        // const refProduct = document.referrer;
        // const refProductRegex = /^https?:\/\/[^\/]+\/(?:collections\/[^\/]+\/)?products\/([^\/?#]+)/;
        // const refProductMatch = refProduct.match(refProductRegex);

        const refProduct = document.referrer;
        const refProductPath = new URL(refProduct).pathname; // ✅ Extract just the path from the full URL
        const refProductRegex = /^\/(?:collections\/[^\/]+\/)?products\/([^\/?#]+)/;
        const refProductMatch = refProductPath.match(refProductRegex);

        console.log(refProductMatch)
        console.log(refProductMatch[1])

        if (refProductMatch && refProductMatch[1]) {
            const previousHandle = refProductMatch[1];

            const usToMx = {
                'mixed-berry': 'hydrate-balance-frutos-rojos',
                'tangerine': 'hydrate-balance-mandarina',
                'passion-fruit': 'hydrate-balance-maracuya',
                'coconut-lime': 'hydrate-balance-coco-con-lima',
                'hydrate-balance-4-flavor-box': 'hydrate-balance-caja-edicion-limitada',
                'hydrate-balance-sample': 'hydrate-balance-paquete-de-muestra',
                'purecreatine': 'purecreatina'
            };

            const mxToUs = Object.fromEntries(Object.entries(usToMx).map(([us, mx]) => [mx, us]));

            const isAlreadyLocalizedProduct = /^\/(es-mx|en-mx|es)\/(?:collections\/[^\/]+\/)?products\//.test(currentPath);

            let targetHandle = null;

            if ((currentRegion === 'es-mx' || currentRegion === 'en-mx') && usToMx.hasOwnProperty(previousHandle)) {
                targetHandle = usToMx[previousHandle];
            } else if (currentRegion === 'us' && mxToUs.hasOwnProperty(previousHandle)) {
                targetHandle = mxToUs[previousHandle];
            } else if (currentRegion === 'us') {
                targetHandle = previousHandle
            }

            if ((targetHandle && previousHandle !== targetHandle) || (previousHandle == targetHandle && currentRegion == 'us')) {
                const prefix = currentRegion === 'us' ? '' : `/${currentRegion}`;
                const base = refProduct.includes('/collections/')
                    ? `/collections/pure-tribe/products/${targetHandle}`
                    : `/products/${targetHandle}`;
                const targetPath = `${prefix}${base}`;

                if (currentPath !== targetPath) {
                    const targetURL = `${window.location.origin}${targetPath}`;
                    window.location.href = targetURL;
                }
            }
        }
    } else {
        const currentPath = window.location.pathname;

        // Base path redirect
        const isBasePath = currentPath === '/' || (!currentPath.includes('/es-mx') && !currentPath.includes('/en-mx'));
        
        if ((storedRegion !== 'us' && isBasePath) && !currentPath.includes('/collections')) {
            window.location = storedRegion;
        }

        // /pages/... redirect
        const isPagesPath = /^\/pages\/[^\/]+$/.test(currentPath);
        const isAlreadyLocalizedPages = /^\/(es-mx|en-mx|es)\/pages\//.test(currentPath);
        if (storedRegion && storedRegion !== 'us' && isPagesPath && !isAlreadyLocalizedPages) {
            const targetURL = `${window.location.origin}/${storedRegion}${currentPath}`;
            window.location.href = targetURL;
        }

        // Product redirect logic
        const usToMx = {
            'mixed-berry': 'hydrate-balance-frutos-rojos',
            'tangerine': 'hydrate-balance-mandarina',
            'passion-fruit': 'hydrate-balance-maracuya',
            'coconut-lime': 'hydrate-balance-coco-con-lima',
            'hydrate-balance-4-flavor-box': 'hydrate-balance-caja-edicion-limitada',
            'hydrate-balance-sample': 'hydrate-balance-paquete-de-muestra',
            'purecreatine': 'purecreatina'
        };

        const mxToUs = Object.fromEntries(Object.entries(usToMx).map(([us, mx]) => [mx, us]));

        const productRegex = /^\/(?:collections\/[^\/]+\/)?products\/([^\/]+)$/;
        const match = currentPath.match(productRegex);

        if (match && match[1]) { 
            const handle = match[1];
            const isAlreadyLocalizedProduct = /^\/(es-mx|en-mx|es)\/(?:collections\/[^\/]+\/)?products\//.test(currentPath);

            let targetHandle = null;

            // Only redirect if handle is in the opposite region's map
            if ((storedRegion === 'es-mx' || storedRegion === 'en-mx') && usToMx.hasOwnProperty(handle)) {
                targetHandle = usToMx[handle];
            } else if (storedRegion === 'us' && mxToUs.hasOwnProperty(handle)) {
                targetHandle = mxToUs[handle];
            }

            // Only redirect if targetHandle is valid and different
            if (targetHandle && handle !== targetHandle) {
                const prefix = storedRegion === 'us' ? '' : `/${storedRegion}`;
                const base = currentPath.includes('/collections/')
                ? `/collections/pure-tribe/products/${targetHandle}`
                : `/products/${targetHandle}`;
                const targetPath = `${prefix}${base}`;

                // Prevent redirect loop
                if (currentPath !== targetPath) { 
                    const targetURL = `${window.location.origin}${targetPath}`;
                    window.location.href = targetURL;
                }
            } 
        }
    }
})();